import React, { Fragment } from 'react';
import Contributor, { ContributorProps } from './Contributor';
import { createStyles, Grid, makeStyles } from '@material-ui/core';
import { ExtendedTheme, TextBlock, Heading, Link } from 'neon-design-system';
import { Publisher } from '../../shared/types';
import { sortArray } from '../../utils/sorting.utils';
import { getPublisherUrl } from '../../utils/utils';

interface ArticleContributorsProps {
	contributors: ContributorProps[];
	publishedBy: Publisher;
	narrow?: boolean;
}

const useStyles = makeStyles<ExtendedTheme>(theme => createStyles({
	root: {
		marginBottom: theme.spacing(6),
		'& > p > a': {
			fontSize: theme.typography.caption.fontSize,
			[theme.breakpoints.up('xl')]: {
				fontSize: 12
			}
		}
	},
	title: {
		marginTop: 0,
		marginBottom: theme.spacing(1)
	},
	label: {
		marginTop: 0,
		marginBottom: theme.spacing(2),
		color: theme.themeColors.grey[400]
	},
	publishedBy: {
		fontWeight: 'bold'
	}
}));

const ArticleContributorList = (props: ArticleContributorsProps) => {
	const classes = useStyles();
	const { contributors, publishedBy, narrow = false } = props;

	if (!contributors.length) {
		return null;
	}

	return (
		<div className={classes.root}>
			<Heading className={classes.title} styleName="title1">
				Contributors
			</Heading>
			<TextBlock
				className={classes.label}
				styleName="caption1"
				xl="large"
			>
				<span id="article-page-contributors-published-by">This article is published by</span>
				<Link className={classes.publishedBy} to={getPublisherUrl(publishedBy)}> {publishedBy?.name}</Link>
			</TextBlock>
			<Grid container spacing={2}>
				{sortArray(contributors, 'name').map((c: ContributorProps) => (
					<Fragment key={c._id}>
						<Grid item xs={12} sm={6} md={narrow ? 4 : 12}>
							<Contributor {...c}/>
						</Grid>
					</Fragment>
				))}
			</Grid>
		</div>
	);
};

export default ArticleContributorList;
